module.exports = __webpack_public_path__ + "img/mark1.ea56ade2.png";